var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.118896,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#4750F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 20.1189H19.3327",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.334 18.7856V13.4523C31.334 11.9796 32.5279 10.7856 34.0007 10.7856",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.666 32.1189V37.4522",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.334 14.9975C30.0475 14.7856 28.3461 14.7856 25.834 14.7856H22.1673C18.2763 14.7856 16.3307 14.7856 14.858 15.5728C13.6952 16.1944 12.7427 17.1468 12.1212 18.3097C11.334 19.7824 11.334 21.7279 11.334 25.619C11.334 27.9536 11.334 29.121 11.8063 30.0046C12.1792 30.7023 12.7507 31.2738 13.4484 31.6467C14.332 32.119 15.4994 32.119 17.834 32.119H30.1673C32.502 32.119 33.6693 32.119 34.5529 31.6467C35.2507 31.2738 35.8221 30.7023 36.1951 30.0046C36.6673 29.121 36.6673 27.9536 36.6673 25.619C36.6673 21.7279 36.6673 19.7824 35.8801 18.3097C35.6481 17.8757 35.3701 17.4711 35.0523 17.102",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6668 32.1189V22.7856C24.6668 21.5469 24.6668 20.9276 24.5847 20.4093C24.1329 17.5567 21.8956 15.3194 19.043 14.8676C18.9339 14.8504 18.8202 14.8367 18.6973 14.8259",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBox);
export default __webpack_public_path__ + "static/media/MailBox.f8078be8f17e26a49938dfa23717fa8e.svg";
export { ForwardRef as ReactComponent };